import { connect } from 'react-redux';

import { getOfferDetailsPromotion } from 'redux/modules/search-and-browse/selectors/promotions';
import { getOfferBuilderItems } from 'redux/modules/entities/selectors/promotions';
import { getWineOfferBuilderItems } from 'redux/modules/entities/selectors/promotions/wine';
import { withRouteProps } from 'utils/with-route-props';
import { WMX_PROMOTION_TYPE_CODE } from 'redux/modules/entities/selectors/promotions/constants';

import OfferDetails from './OfferDetails';

export default withRouteProps(
  connect(
    (
      state,
      {
        match: {
          params: { offerId: promotionId },
        },
      },
    ) => {
      const promotion = getOfferDetailsPromotion(state, promotionId);

      const isWineBuilder = promotion?.promotionTypeCode === WMX_PROMOTION_TYPE_CODE;

      const promotionBuilders = isWineBuilder
        ? getWineOfferBuilderItems(state, promotionId)
        : getOfferBuilderItems(state, promotionId);

      return {
        promotion,
        promotionId,
        promotionBuilders,
        isWineBuilder,
      };
    },
  )(OfferDetails),
);
